export default __webpack_public_path__ + "static/media/b02.21fe4a1b.jpg";